document.addEventListener('DOMContentLoaded', () => {
    const chars = 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ';
  const blocks = document.querySelectorAll('[data-scramble]');
  if (!blocks.length) return;

  const animate = el => {
    if (el._scrambleFrame) {
      cancelAnimationFrame(el._scrambleFrame);
    }

    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const originalDisplay = el.style.display;
    const computedDisplay = getComputedStyle(el).display;
    if (computedDisplay === 'inline') {
      el.style.display = 'inline-block';
    }
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;

    const getTextNodes = node => {
      const nodes = [];
      node.childNodes.forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          nodes.push(child);
        } else {
          nodes.push(...getTextNodes(child));
        }
      });
      return nodes;
    };
    const isWhitespace = char => /\s/.test(char);
    const randomChar = () => chars[Math.floor(Math.random() * chars.length)];
    const textNodes = el._scrambleNodes || getTextNodes(el);
    const originals = el._scrambleOriginals || textNodes.map(n => n.textContent);
    el._scrambleNodes = textNodes;
    el._scrambleOriginals = originals;

    const originalsChars = originals.map(t => [...t]);
    const scrambledChars = originalsChars.map(arr => arr.slice());
    const totalLength = originalsChars.reduce((sum, arr) => sum + arr.length, 0);
    let progress = 0;
    let frame = 0;
    const mode = el.dataset.scrambleMode || 'reveal';

    const renderScramble = scrambleProgress => {
      frame++;
      let offset = 0;
      textNodes.forEach((node, idx) => {
        const updated = originalsChars[idx].map((ch, i) => {
          const globalIndex = offset + i;
          if (globalIndex < scrambleProgress && !isWhitespace(ch)) {
            if (scrambledChars[idx][i] === ch || frame % 2 === 0) {
              scrambledChars[idx][i] = randomChar();
            }
            return scrambledChars[idx][i];
          }
          return ch;
        });
        node.textContent = updated.join('');
        offset += originalsChars[idx].length;
      });
    };

    const renderReveal = revealProgress => {
      frame++;
      let offset = 0;
      textNodes.forEach((node, idx) => {
        const updated = originalsChars[idx].map((ch, i) => {
          const globalIndex = offset + i;
          if (globalIndex < revealProgress) {
            return ch;
          }
          if (!isWhitespace(ch)) {
            if (scrambledChars[idx][i] === ch || frame % 2 === 0) {
              scrambledChars[idx][i] = randomChar();
            }
            return scrambledChars[idx][i];
          }
          return ch;
        });
        node.textContent = updated.join('');
        offset += originalsChars[idx].length;
      });
    };

    const finish = () => {
      textNodes.forEach((node, idx) => {
        node.textContent = originals[idx];
      });
      el.style.width = '';
      el.style.height = '';
      el.style.display = originalDisplay;
      delete el._scrambleFrame;
    };

    const revealStep = () => {
      renderReveal(progress);
      progress += 1;
      if (progress <= totalLength) {
        el._scrambleFrame = requestAnimationFrame(revealStep);
      } else {
        finish();
      }
    };

    const scrambleStep = () => {
      renderScramble(progress);
      progress += 1;
      if (progress <= totalLength) {
        el._scrambleFrame = requestAnimationFrame(scrambleStep);
      } else {
        progress = 0;
        revealStep();
      }
    };

    if (mode === 'pulse') {
      scrambleStep();
    } else {
      renderScramble(totalLength);
      progress = 0;
      el._scrambleFrame = requestAnimationFrame(revealStep);
    }
  };

  const init = el => {
    const isPulse = el.dataset.scrambleMode === 'pulse';
    if (isPulse) {
      const time = parseInt(el.dataset.scrambleInterval || '7', 10) * 1000;
      if (!el._scrambleInterval) {
        el._scrambleInterval = setInterval(() => animate(el), time);
        setTimeout(() => animate(el), 0);
      }
    } else {
      animate(el);
    }
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          init(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });
    blocks.forEach(el => observer.observe(el));
  } else {
    blocks.forEach(init);
  }
});
